<!-- 创建时间2023/06/16 09:00:22 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：完课标准 -->
<template>
  <!-- 三方课-内嵌-支持提供获取学习进度的接口时 -->
  <!-- 三方课-内嵌-不支持提供获取学习进度的接口时 -->
  <!-- 三方课-不允许内嵌-支持提供获取学习进度的接口时 -->
  <!-- 三方课-不允许内嵌-不支持提供获取学习进度的接口时 -->
  <!-- 音视频-时长 -->
  <!-- 微课-时长 -->
  <!-- 微课-时长+内容 -->
  <!-- scorm-时长 -->
  <!-- scorm-时长+内容 -->
  <!-- scorm-内容 -->
  <!-- 外链 -->

  <div v-if="completeTypes.length">
    <yxt-radio-group
      v-if="completeTypes.length > 1"
      v-model="type"
      type="tab-radio"
      :disabled="disabled"
    >
      <yxt-radio-button
        :label="item.value"
        :key="item.value"
        v-for="item in completeTypes"
      >
        <div class="yxtbiz-flex-center">
          {{ item.label }}
          <yxt-tooltip
            v-if="item.tooltip"
            effect="dark"
            :content="item.tooltip"
            placement="top"
          >
            <yxt-svg
              icon-class="question-cirlce-o"
              class="ml4"
              width="16px"
              height="16px"
            ></yxt-svg>
          </yxt-tooltip>
        </div>
      </yxt-radio-button>
    </yxt-radio-group>
    <div v-if="type === 'time' || type === 'timeAndContent'" class="yxtbiz-flex-center" :class="completeTypes.length > 1 ? 'mt12' : ''">
      <yxtbiz-language-slot lang-key="pc_biz_lbl_studytimepercent">
        <yxt-select
          v-model="percent"
          class="yxtbiz-w100"
          slot="0"
          :disabled="disabled"
          @change="change"
        >
          <yxt-option label="100%" :value="100"></yxt-option>
          <yxt-option label="95%" :value="95"></yxt-option>
          <yxt-option label="90%" :value="90"></yxt-option>
          <yxt-option label="85%" :value="85"></yxt-option>
          <yxt-option label="80%" :value="80"></yxt-option>
          <div slot="fixed-footer">
            <yxt-input-number
              v-model="customPercent"
              class="yxtbiz-w110"
              size="small"
              :precision="0"
              :max="100"
              :min="1"
              :formatter="value => (value ? `${value}%` : '')"
              :placeholder="$t('pc_kng_standard_lbl_custom'/** 自定义 */)"
            ></yxt-input-number>
          </div>
        </yxt-select>
      </yxtbiz-language-slot>
      <span v-if="info.type === KNG_TYPE.HTML && info.playType === 1" class="color-gray-6">
        {{ $t('pc_kng_uplaoder_lbl_original_video_stream'/** (该视频课件来源于第三方供应商，系统将获取原视频流进行播放) */) }}
      </span>
    </div>
    <div v-if="type === 'progress'">
      {{ $t('pc_kng_uplaoder_lbl_supplier_process_delay' /**该课件来源于第三方供应商，获取学习进度存在延迟*/) }}
    </div>
    <div v-if="type === 'immediate'">
      {{ $t('pc_biz_kng_lbl_completestandard3' /** 进入课件播放页即完成学习且获得学分 */) }}
      <span class="color-gray-6">
        {{ $t('pc_kng_uplaoder_lbl_supplier_only_jump_learning' /**（该课件来源于第三方供应商，仅支持跳转学习）*/) }}</span>
    </div>
    <div v-if="type === 'outer'">
      {{ $t('pc_kng_uplaoder_lbl_standard_newlink_tip' /** 学员打开课件即算完课（无学时、学分） */) }}
    </div>
    <div v-if="type === 'content' || type === 'timeAndContent'">
      {{ $t('pc_kng_uplaoder_intro_onlycontentComplete_content' /** 完成课件内容获得学分 */) }}
    </div>
    <div class="standard-size-12 yxt-color-warning" v-if="showScormWarn">
      {{ $t('pc_kng_uplaoder_intro_standard_4'/** 课件发布之后，完课标准无法再次编辑 */) }} 
    </div>
  </div>
</template>

<script>
import { KNG_TYPE } from 'yxt-biz-pc/packages/select-kng/src/const';
export default {
  name: 'form-complete-standard',
  props: {
    contentCompleteStandard: {
      type: Number,
      default: 0
    },
    timeCompleteStandard: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  inject: ['getInfo', 'getIsEdit'],
  data() {
    return {
      KNG_TYPE,
      customPercent: undefined,
      percent: ''
    };
  },
  computed: {
    info() {
      return this.getInfo();
    },
    showScormWarn() {
      return this.info.type === KNG_TYPE.SCORM && !this.getIsEdit();
    },
    completeTypes() {
      let list = [];
      const { specialMode, type, scheduleCallback, playType, weikeType } = this.info;
      if (
        specialMode &&
        type === KNG_TYPE.HTML &&
        scheduleCallback &&
        playType === 2
      ) {
        list.push({
          label: this.$t('pc_kng_courseware_standard_lbl_duration'/** 时长 */),
          value: 'time',
          tooltip: this.$t('pc_kng_uplaoder_lbl_standard_tip'/** 完成标准学时，即可获得学分 */)
        });
        list.push({
          label: this.$t('pc_kng_lbl_scorm_study_schedule'/** 学习进度 */),
          value: 'progress',
          tooltip: this.$t('pc_kng_uplaoder_lbl_supplier_process'/** 课程供应商提供学习进度为完成，即可获得学分 */)
        });
      } else if (
        specialMode &&
        type === KNG_TYPE.HTML &&
        !scheduleCallback &&
        playType === 2
      ) {
        list.push({
          label: this.$t('pc_kng_courseware_standard_lbl_duration'/** 时长 */),
          value: 'time',
          tooltip: this.$t('pc_kng_uplaoder_lbl_standard_tip'/** 完成标准学时，即可获得学分 */)
        });
      } else if (
        specialMode &&
        type === KNG_TYPE.HTML &&
        scheduleCallback &&
        playType === 3
      ) {
        list.push({ label: this.$t('pc_biz_lbl_clickcomplete'/** 点击立即完成 */), value: 'immediate' });
        list.push({
          label: this.$t('pc_kng_lbl_scorm_study_schedule'/** 学习进度 */),
          value: 'progress',
          tooltip: this.$t('pc_kng_uplaoder_lbl_supplier_process'/** 课程供应商提供学习进度为完成，即可获得学分 */)
        });
      } else if (
        specialMode &&
        type === KNG_TYPE.HTML &&
        scheduleCallback &&
        playType === 3
      ) {
        list.push({ label: this.$t('pc_biz_lbl_clickcomplete'/** 点击立即完成 */), value: 'immediate' });
      } else if (specialMode && type === KNG_TYPE.HTML && playType === 1) {
        list.push({
          label: this.$t('pc_kng_courseware_standard_lbl_duration'/** 时长 */),
          value: 'time',
          suffix: this.$t('pc_kng_uplaoder_lbl_original_video_stream'/** (该视频课件来源于第三方供应商，系统将获取原视频流进行播放) */)
        });
      } else if (type === KNG_TYPE.NEWLINK) {
        list.push({ label: this.$t('pc_biz_lbl_clickcomplete'/** 点击立即完成 */), value: 'outer' });
      } else if (type === KNG_TYPE.WEIKE && weikeType === 2) {
        list.push({
          label: this.$t('pc_kng_courseware_standard_lbl_duration'/** 时长 */),
          value: 'time',
          tooltip: this.$t('pc_kng_uplaoder_lbl_standard_tip'/** 完成标准学时，即可获得学分 */)
        });
        list.push({
          label: this.$t('pc_kng_courseware_standard_lbl_content'/** 内容 */),
          value: 'content',
          tooltip: this.$t('pc_kng_uplaoder_scorm_content_tip'/** 完成课件内容即可获得学分（需要课件支持内容记录，否则学员无法完成该课件） */)
        });
        list.push({
          label: this.$t('pc_kng_uplaoder_btn_standard_cont'/** 时长和内容 */),
          value: 'timeAndContent',
          tooltip: this.$t('pc_kng_uplaoder_lbl_standard_cont_tip'/** 完成标准学时和内容进度，即可获得学分（需课件支持内容记录） */)
        });
      } else if (type === KNG_TYPE.WEIKE) {
        list.push({
          label: this.$t('pc_kng_courseware_standard_lbl_duration'/** 时长 */),
          value: 'time',
          tooltip: this.$t('pc_kng_uplaoder_lbl_standard_tip'/** 完成标准学时，即可获得学分 */)
        });
      } else if (type === KNG_TYPE.SCORM) {
        list.push({
          label: this.$t('pc_kng_courseware_standard_lbl_duration'/** 时长 */),
          value: 'time',
          tooltip: this.$t('pc_kng_uplaoder_lbl_standard_tip'/** 完成标准学时，即可获得学分 */)
        });
        list.push({
          label: this.$t('pc_kng_courseware_standard_lbl_content'/** 内容 */),
          value: 'content',
          tooltip: this.$t('pc_kng_uplaoder_scorm_content_tip'/** 完成课件内容即可获得学分（需要课件支持内容记录，否则学员无法完成该课件） */)
        });
        list.push({
          label: this.$t('pc_kng_uplaoder_btn_standard_cont'/** 时长和内容 */),
          value: 'timeAndContent',
          tooltip: this.$t('pc_kng_uplaoder_lbl_standard_cont_tip'/** 完成标准学时和内容进度，即可获得学分（需课件支持内容记录） */)
        });
      } else if (type === KNG_TYPE.AUDIO || type === KNG_TYPE.VIDEO) {
        list.push({
          label: this.$t('pc_kng_courseware_standard_lbl_duration'/** 时长 */),
          value: 'time',
          tooltip: this.$t('pc_kng_uplaoder_lbl_standard_tip'/** 完成标准学时，即可获得学分 */)
        });
      }
      return list;
    },
    type: {
      get() {
        const { contentCompleteStandard, timeCompleteStandard } = this;
        const { type } = this.info;
        if (type === KNG_TYPE.NEWLINK) {
          return 'outer';
        } else if (contentCompleteStandard === 2 && !timeCompleteStandard) {
          return 'progress';
        } else if (contentCompleteStandard === 3 && !timeCompleteStandard) {
          return 'immediate';
        } else if (contentCompleteStandard === 1 && !timeCompleteStandard) {
          return 'content';
        } else if (!contentCompleteStandard && timeCompleteStandard) {
          return 'time';
        } else if (contentCompleteStandard && timeCompleteStandard) {
          return 'timeAndContent';
        }
        return '';
      },
      set(val) {
        this.customPercent = undefined;
        if (val === 'progress') {
          this.$emit('update:contentCompleteStandard', 2);
          this.$emit('update:timeCompleteStandard', 0);
        } else if (val === 'immediate') {
          this.$emit('update:contentCompleteStandard', 3);
          this.$emit('update:timeCompleteStandard', 0);
        } else if (val === 'outer') {
          this.$emit('update:contentCompleteStandard', 0);
          this.$emit('update:timeCompleteStandard', 100);
        } else if (val === 'content') {
          this.$emit('update:contentCompleteStandard', 1);
          this.$emit('update:timeCompleteStandard', 0);
        } else if (val === 'time') {
          this.$emit('update:contentCompleteStandard', 0);
          this.$emit('update:timeCompleteStandard', 100);
        } else if (val === 'timeAndContent') {
          this.$emit('update:contentCompleteStandard', 1);
          this.$emit('update:timeCompleteStandard', 100);
        }
      }
    }
  },
  watch: {
    timeCompleteStandard: {
      immediate: true,
      handler(val) {
        if ([100, 95, 90, 85, 80].includes(val)) {
          this.percent = val;
        } else {
          this.percent = val + '%';
          this.customPercent = val;
        }
      }
    },
    customPercent(val) {
      if (val === 0) return;
      if (val) {
        this.percent = val + '%';
      } else {
        this.percent = 100;
      }
    },
    percent() {
      this.$emit('update:timeCompleteStandard', parseInt(this.percent, 10));
    }
  },
  methods: {
    change() {
      this.customPercent = undefined;
    }
  }
};
</script>